import React, { useState, useEffect, useContext, useRef } from 'react'
import { StoreContext } from '../store'

import { ReactComponent as Action } from '../assets/add-circle.svg'
import { ReactComponent as Minus } from '../assets/minus-circle.svg'

import Show from './Show'

export const CategorySearch = ({
  className = '',
  placeholder = 'Enter location',
  index,
  onClick = null,
  value = '',
  onClear = null,
  onChange = null,
  isClearable = false,
  icon = null,
  dispatch,
}) => {
  const { state } = useContext(StoreContext)
  const { currentView, isExploreEnabled } = state

  const inputRef = useRef()
  const debounceRef = useRef(null)

  const [predictions, setPredictions] = useState([])
  const [showResult, setShowResult] = useState(false)
  const [inputValue, setInputValue] = useState(value)
  const [isFocused, setIsFocused] = useState(false)

  const isModern = currentView === 'Modern'

  useEffect(() => {
    setInputValue(value || '')
  }, [value])

  const handleSearchChange = (event) => {
    const val = event.target.value
    setInputValue(val)

    if (debounceRef.current) clearTimeout(debounceRef.current)

    debounceRef.current = setTimeout(() => {
      if (onChange) onChange(event)

      if (!val) {
        setPredictions([])
      } else {
        // If you have prediction logic, trigger it here
        // searchAddress()
      }
    }, 300)
  }

  const handleClear = () => {
    setInputValue('')
    setIsFocused(false)
    dispatch({ type: 'REMOVE_CATEGORY', payload: [inputValue] });
    if (onClear) onClear(index)
  }

  const handleFocus = () => {
    setIsFocused(true)
    setShowResult(predictions.length > 0)
  }

  const handleBlur = () => {
    setIsFocused(false)
    setShowResult(false)
  }

  return (
    <div className={`autocomplete-wrapper relative w-full ${className}`}>
      <div className="flex items-center border rounded px-3 py-2 bg-white">
        {icon && React.createElement(icon, { className: 'w-[15px] h-[15px] mr-2' })}

        <input
          ref={inputRef}
          value={inputValue}
          onChange={handleSearchChange}
          onFocus={handleFocus}
          onBlur={handleBlur}
          placeholder={placeholder}
          autoComplete="off"
          className="w-full outline-none text-black text-xs"
        />

        <Show.When isTrue={isClearable && index !== 0 && !isExploreEnabled}>
          <Minus onClick={handleClear} className="cursor-pointer w-4 h-4 ml-2" />
        </Show.When>
      </div>
    </div>
  )
}